import {
  type ContactChildConnectionType,
  type ContactRelatedConnectionType,
} from "@/lib/data/schemas/contact/ContactSchema";

/**
 * Recursively flattens all child connections into a single array
 * @param connections - The initial array of child connections
 * @returns A flat array containing all child connections at all levels
 */
export const flattenChildConnections = (
  connections?: ContactChildConnectionType[],
): ContactChildConnectionType[] => {
  if (!connections || connections.length === 0) {
    return [];
  }

  const flattened: ContactChildConnectionType[] = [];

  for (const connection of connections) {
    // Add the current connection
    flattened.push(connection);

    // Recursively add any nested child connections
    flattened.push(...flattenChildConnections(connection.childConnections));
  }

  return flattened;
};

/**
 * Recursively flattens all related connections into a single array
 * @param connections - The initial array of related connections
 * @returns A flat array containing all related connections at all levels
 */
export const flattenRelatedConnections = (
  connections?: ContactRelatedConnectionType[],
): ContactRelatedConnectionType[] => {
  if (!connections || connections.length === 0) {
    return [];
  }

  const flattened: ContactRelatedConnectionType[] = [];

  for (const connection of connections) {
    // Add the current connection
    flattened.push(connection);

    // Recursively add any nested related connections
    flattened.push(...flattenRelatedConnections(connection.relatedConnections));
  }

  return flattened;
};
